import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { InputAppAPIHelperUtil } from '@monorepo/utils';
import * as _ from 'lodash';
import { CutbankInFacade, InputAppClientDBFacade } from '@monorepo/core-data';
import { InputAppDataService } from '@monorepo/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-tag-history-modal',
  templateUrl: './tag-history-modal.component.html',
  styleUrls: ['./tag-history-modal.component.scss'],
  providers: [DatePipe],
})
export class TagHistoryModalComponent implements OnInit {
  conf: Record<string, any> = {};
  data: any[] = [];
  details: Record<string, string> = {};
  tagId: string = '';
  subjectKey: string = '';
  @Input() useSearchId: boolean = false;

  public set config(value: any) {
    this.conf = value;
  }
  constructor(
    private modalController: ModalController,
    private apiHelper: InputAppAPIHelperUtil,
    private inputAppDataProvider: InputAppDataService,
    private datePipe: DatePipe,
    private inputAppClientDBFacade: InputAppClientDBFacade,
    private cutBankFacade: CutbankInFacade,
    private translate: TranslateService,
  ) {
    this.inputAppClientDBFacade.getSubjectKey().subscribe((key) => {
      this.subjectKey = key;
    });
  }

  ngOnInit(): void {}

  closeModal() {
    this.modalController.dismiss();
  }

  async searchTagId() {
    if (this.tagId && this.tagId !== '') {
      this.data = [];
      this.details = {};

      if (this.useSearchId) {
        this.cutBankFacade.getCutTagSearchId(this.tagId).subscribe((res) => {
          if (res) {
            this.#searchTagHistory(res);
          }
        });
      } else {
        this.#searchTagHistory(this.tagId);
      }
    }
  }

  async #searchTagHistory(tagId: string) {
    await this.apiHelper.presentLoading('Please wait...');

    this.inputAppDataProvider.searchTagHistory(this.createRequest(tagId)).subscribe(
      async (res: any) => {
        await this.apiHelper.dismissLoading();
        console.log(res);
        if (res instanceof Array) {
          this.searchTagHistorySetValues(res);
          this.data = res;
        } else {
          if (res['tag_history_search_request'] && res['tag_history_search_request'] instanceof Array) {
            const result = res['tag_history_search_request'];
            this.searchTagHistorySetValues(result);
            this.data = result;
          }
        }
        const __this = this;
        if (this.data.length === 1) {
          this.details = this.data[0];
          _.forEach(this.conf['summary_props'], function (prop) {
            if (_.isEmpty(__this.details[prop])) {
              __this.details[prop] = '--';
            }
          });
        } else if (this.data.length > 0) {
          const arr = JSON.parse(JSON.stringify(this.data));
          arr.reverse();
          let details = {};
          _.forEach(arr, function (data, id) {
            details = arr[id].details;
            if (details) {
              __this.details = details;
              return false;
            }
            return true;
          });
          _.forEach(this.conf['summary_props'], function (prop) {
            if (_.isEmpty(__this.details[prop])) {
              __this.details[prop] = '--';
            }
          });
        }
      },
      async (err: Error) => {
        await this.apiHelper.dismissLoading();
        this.apiHelper.showPopup('Error', 'Something went wrong!');
        console.log('Timeline modal doSearch error: ', err);
      },
    );
  }

  createRequest(tagId: string) {
    const args = this.conf['args'];

    args.forEach((arg: any) => {
      if (arg['key'] === '@sk') {
        arg['value'] = this.subjectKey;
      } else if (arg['key'] === '@window') {
        arg['value'] = this.getNDaysTime(arg['n']);
      } else if (arg['key'] === '@tag_id') {
        arg['value'] = tagId;
      }
    });

    const request: any = {};
    request['subject_key'] = this.subjectKey;
    request['requests'] = [];

    const obj = {
      req_id: this.conf['request_id'],
      req_args: args,
    };
    request['requests'].push(obj);
    return request;
  }

  getNDaysTime(num: number): string {
    const startDate = new Date();
    const client = Math.abs(startDate.getTimezoneOffset());
    const mins = client % 60;
    const hours = Math.trunc(client / 60);
    const n = startDate.getDate() - num;
    startDate.setHours(hours, mins);

    let time1 = startDate.getTime();
    time1 = time1 + 23 * 60 * 60 * 1000 + 59 * 60000; // end of the day time

    const endDate = new Date(time1);
    startDate.setDate(n);
    return startDate.toISOString() + '/' + endDate.toISOString();
  }

  searchTagHistorySetValues(data: any[] = []) {
    // remove checkin rows that duplicate a scan event (same station + date/time); keep all other rows
    const scanEventKeys = new Set(
      data
        .filter((row) => row.datetime)
        .map((row) => this.#scanKey(row.dn, this.datePipe.transform(row.datetime, 'yyyy-MM-dd HH:mm:ss'))),
    );
    _.remove(
      data,
      (row) => row.status === 'checkin' && scanEventKeys.has(this.#scanKey(row.domRole_dn, `${row.date} ${row.time}`)),
    );
    data.forEach((item) => {
      if (item.status === 'new') {
        item.status = 'added';
      }
      if (item.status === 'checkin' && item.qty > 0) {
        item.status = 'added';
      }
      if (item.qty < 0) {
        item.status = 'undo';
      }
      if (item.hasOwnProperty('datetime')) {
        item.date = this.datePipe.transform(item.datetime, 'yyyy-MM-dd');
        item.time = this.datePipe.transform(item.datetime, 'HH:mm:ss');
      }
    });
    data.sort(function (a, b) {
      const keyA = new Date(a.date + ' ' + a.time),
        keyB = new Date(b.date + ' ' + b.time);
      // Compare the 2 dates
      if (keyA > keyB) {
        return -1;
      }
      if (keyA < keyB) {
        return 1;
      }
      return 0;
    });
  }

  #scanKey(stationName: string | undefined, timestamp: string | null): string {
    return `${(stationName ?? '').trim().toLowerCase()}|${timestamp}`;
  }
}
